const styleContainer = { 
         position: 'relative',
        top: '-32px',
        left: '-32px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        background: '#fff',
        color: 'rgb(255, 255, 255)',
        transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        boxSizing: 'border-box',
        fontFamily: 'Roboto, sans-serif',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
        borderRadius: '2px',
        zIndex: '1',
        opacity: '1',
    }
const styleContainerTitle = {
    padding: '16px', 
    position: 'relative',
}

const styleTitle = {
    fontSize: '24px', 
    color: 'rgba(0, 0, 0, 0.87)',
}

const styleButton = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
export{
    styleContainer,
    styleContainerTitle,
    styleTitle,
    styleButton,
}